import { createSlice } from "@reduxjs/toolkit";

import bike from "../../assets/img/bike-Loop.gif";
import car from "../../assets/img/Car-Loop.gif";
import fan from "../../assets/img/Fan-Loop.gif";
import gym from "../../assets/img/Gym-Loop.gif";
import mchine2 from "../../assets/img/Treadmill-Loop.gif";
import Bag from "../../assets/img/Bag.png";
import Mixer from "../../assets/img/Mixer.png";
import Chair from "../../assets/img/Chair.png";
import TableFan from "../../assets/img/TableFan.png";



const initialState = {
  /* added mobile and web version 3d images for new products and have to replace the mobile version image for car product  */
  modalsPreview: [
    {
      id: 1,
      title: "Bike",
      img: bike,
      mobileModal:
        "https://vho.bizconnectevents.com/Biz3D/Bike+Mobile+Version/index.html",
      webModel: "https://vho.bizconnectevents.com/Biz3D/Bike/index.html",
    },

    {
      id: 2,
      title: "Car",
      img: car,
      mobileModal:
        "https://vho.bizconnectevents.com/BizCar/CARV3/index.html",
      webModel: "https://vho.bizconnectevents.com/BizCar/CARV3/index.html",
    },

    {
      id: 3,
      title: "Fan",
      img: fan,
      mobileModal:
        "https://vho.bizconnectevents.com/Biz3D/Fan/Mobile+Fan/index.html",
      webModel: "https://vho.bizconnectevents.com/Biz3D/Fan/Web+Fan/index.html",
    },
    {
      id: 4,
      title: "Gym",
      img: gym,
      mobileModal:
        "https://vho.bizconnectevents.com/Biz3D/RunningMachine+Mobile+Version/index.html",
      webModel: "https://vho.bizconnectevents.com/Biz3D/Gym/index.html",
    },

    {
      id: 5,
      title: "Treadmill",
      img: mchine2,
      mobileModal:
        "https://vho.bizconnectevents.com/Biz3D/Fan/Mobile+Fan/index.html",
      webModel: "https://vho.bizconnectevents.com/Biz3D/RunnerMachin/index.html",
    },
    // {
    //   id: 6,
    //   title: "Table Fan",
    //   img: TableFan,
    //   mobileModal:
    //     "https://62d6a171f767f514155fc7cf--fan-mob.netlify.app/",
    //   webModel: "https://62d6a2c1d6207f15e0e3be3b--fan-web.netlify.app/",
    // },
    // {
    //   id: 7,
    //   title: "Mixer",
    //   img: Mixer,
    //   mobileModal:
    //     "https://62d6a1c4374efb12ce77ba17--mixer-mob.netlify.app/",
    //   webModel: "https://62d6a27ca723ce1765939980--mixer-web.netlify.app/",
    // },
    // {
    //   id: 8,
    //   title: "Chair",
    //   img: Chair,
    //   mobileModal:
    //     "https://62d6a134990e3f1472da7ebb--chair-mob.netlify.app/",
    //   webModel: "https://62d6a21c934590152881c512--chair-web.netlify.app/",
    // },
    // {
    //   id: 9,
    //   title: "Bag",
    //   img: Bag,
    //   mobileModal:
    //     "https://62d6a0e5d6207f1444e3bd15--bag-mob.netlify.app/",
    //   webModel: "https://62d6a1ebfbaa76138c340e7f--bag-web.netlify.app/",
    // },
  ],

  currentIframeLink: "",
};

// The function below is called a thunk and allows us to perform async logic. It
// can be dispatched like a regular action: `dispatch(createUserAsync(10))`. This
// will call the thunk with the `dispatch` function as the first argument. Async
// code can then be executed and other actions can be dispatched. Thunks are
// typically used to make async requests.

export const allModelsSlice = createSlice({
  name: "allModels",
  initialState,
  // The `reducers` field lets us define reducers and generate associated actions
  reducers: {
    setCurrentIframeLink: (state, action) => {
      // action.payload.obj
      state.currentIframeLink = action.payload.link;
    },
  },
  // The `extraReducers` field lets the slice handle actions defined elsewhere,
  // including actions generated by createAsyncThunk or in other slices.
  extraReducers: (builder) => {},
});

export const { setCurrentIframeLink } = allModelsSlice.actions;

// The function below is called a selector and allows us to select a value from
// the state. Selectors can also be defined inline where they're used instead of
// in the slice file. For example: `useSelector((state: RootState) => state.counter.value)`
export const allModelsState = (state) => state.allModels;

// We can also write thunks by hand, which may contain both sync and async logic.
// Here's an example of conditionally dispatching actions based on current state.
export const incrementIfOdd = (amount) => (dispatch, getState) => {
  const currentValue = allModelsState(getState());
  if (currentValue % 2 === 1) {
    // dispatch(incrementByAmount(amount));
  }
};

export default allModelsSlice.reducer;
